import { toast } from 'react-toastify'

export const notifyError = (text, delay = 2500) => {
  toast.error(text, {
    position: 'bottom-right',
    autoClose: delay,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  })
}

export const notifySuccess = (text, delay = 2500) => {
  toast.success(text, {
    position: 'bottom-right',
    autoClose: delay,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  })
}
